<template>
    <div>
        <div class="modal-body">
            <el-button @click="handleSwapDate()" v-if="$parentInfo.powers.includes(151)">互换日期课程</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_DailyTableSite",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleSwapDate() {
                this.$Win.openModal('Dialog_SwapDate', 440, 430, '互换日期课程');
            },
        }
    }
</script>

<style scoped>

</style>